import React, { Component } from 'react'
import Container from '../common/application_container'
import AddAccountPageComponent from './addAccountPageComponent';


export class AddAccountPage extends Component {
    render() {
        return (
            <Container title="Accounts Create" title1="Section" icon="fa fa-user">
                <AddAccountPageComponent />
            </Container>
        )
    }
}

export default AddAccountPage
